var Shared;
(function (Shared) {
    function calendarEventText() {
        return {
            scope: {
                model: "="
            },
            template: "<span>{{model}}</span>"
        };
    }
    Shared.calendarEventText = calendarEventText;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    var Calendar = (function () {
        function Calendar($rootScope, calendarSvc, responsiveSvc) {
            var _this = this;
            this.calendarSvc = calendarSvc;
            this.responsiveSvc = responsiveSvc;
            this.weeks = [];
            this.weeks = [];
            $rootScope.$watchGroup([function () { return _this.calendarSvc.range; }, function () { return _this.calendarSvc.events.length; }], function () { return _this.refresh(); });
        }
        Calendar.prototype.refresh = function () {
            if (!this.calendarSvc.range) {
                return;
            }
            _.each(this.calendarSvc.events, function (a) { return a.position = undefined; });
            this.calculateDisplayRange();
            this.updateDates();
            this.updateWeeks();
        };
        Calendar.prototype.calculateDisplayRange = function () {
            var start = moment(this.calendarSvc.range.start);
            var end = moment(this.calendarSvc.range.end);
            if (this.calendarSvc.events.length) {
                var first = moment(_(this.calendarSvc.events)
                    .map(function (a) { return a.range.start; })
                    .sortBy(function (a) { return a; })
                    .value()[0]);
                var last = moment(_(this.calendarSvc.events)
                    .map(function (a) { return a.range.end; })
                    .sortBy(function (a) { return a; })
                    .reverse()
                    .value()[0]);
                if (start.diff(first) > 0) {
                    start = first;
                }
                if (end.diff(last) < 0) {
                    end = last;
                }
            }
            this.displayRange =
                {
                    dates: this.calendarSvc.datesInRange({
                        start: start.add(-start.day(), "days").format(),
                        end: end.add(6 - end.day(), "days").format()
                    }),
                    end: end.format(),
                    start: start.format()
                };
        };
        Calendar.prototype.eventInstance = function (event, date, instance) {
            var result = {
                daysInWeek: 0,
                event: event,
                includesSaturday: false,
                includesEnd: false,
                includesStart: false,
                instance: instance,
                isSunday: date.day() === 0
            };
            var daysRemaining = this.calendarSvc.datesInRange({
                end: event.range.end,
                start: date.format()
            });
            for (var i = 0; i < daysRemaining.length; i++) {
                result.daysInWeek++;
                if (moment(daysRemaining[i]).day() === 6) {
                    result.includesSaturday = true;
                    break;
                }
            }
            result.includesStart = event.dates[0] === date.format();
            result.includesEnd = moment(event.range.end).format() === moment(date).add(result.daysInWeek - 1, "days").format();
            return result;
        };
        Calendar.prototype.updateDates = function () {
            var _this = this;
            this.listDates = [];
            var calendarDates = this.calendarSvc.datesInRange(this.calendarSvc.range);
            _.each(this.calendarSvc.events, function (a) {
                if (!a.dates) {
                    a.dates = _this.calendarSvc.datesInRange(a.range);
                }
            });
            var eventInstances = [];
            this.dates = _.map(this.displayRange.dates, function (a) {
                var date = moment(a);
                var events = _.filter(_this.calendarSvc.events, function (b) { return _.includes(b.dates, a); });
                if (calendarDates.indexOf(a) > -1 && events.length) {
                    _this.listDates.push({
                        date: a,
                        events: _.sortBy(events, function (a) { return a.range.start; })
                    });
                }
                var slots = Math.max(events.length, _.max(_.map(events, function (a) { return a.position || 0; })) || 0);
                var result = [];
                for (var i = 1; i <= slots; i++) {
                    var event = _.find(events, function (a) { return a.position === i; });
                    if (event) {
                        if (date.day() === 0) {
                            var instance = _this.eventInstance(event, date, _.filter(eventInstances, function (b) { return (!!b && b.event === event); }).length + 1);
                            eventInstances.push(instance);
                            result.push(instance);
                        }
                        else {
                            result.push(undefined);
                        }
                    }
                    else {
                        event = _(events)
                            .filter(function (a) { return !a.position; })
                            .sortBy(function (a) { return a.dates.length; })
                            .value()[0];
                        if (event) {
                            event.position = i;
                            var instance = _this.eventInstance(event, date, _.filter(eventInstances, function (b) { return (!!b && b.event === event); }).length + 1);
                            eventInstances.push(instance);
                            result.push(instance);
                        }
                        else {
                            result.push(undefined);
                        }
                    }
                }
                return {
                    date: a,
                    events: result,
                    inRange: true,
                    isToday: moment().format("YYYYMMD") === date.format("YYYYMMD")
                };
            });
        };
        Calendar.prototype.updateWeeks = function () {
            var _this = this;
            this.weeks.length = 0;
            var week = {
                days: []
            };
            var range = this.calendarSvc.datesInRange(this.calendarSvc.range);
            var weekNumber = 1;
            _.each(this.dates, function (a) {
                if (week.days.length === 7) {
                    if (_this.calendarSvc.useWeekLabels && _.some(week.days, function (b) { return b.inRange; })) {
                        week.label = "Week " + weekNumber;
                        ;
                        weekNumber++;
                    }
                    _this.weeks.push(week);
                    week =
                        {
                            days: []
                        };
                }
                a.inRange = range.indexOf(a.date) > -1;
                week.days.push(a);
            });
            if (week.days.length) {
                if (this.calendarSvc.useWeekLabels && _.some(week.days, function (b) { return b.inRange; })) {
                    week.label = "Week " + weekNumber;
                }
                this.weeks.push(week);
            }
        };
        Calendar.$inject = ["$rootScope", "Shared.CalendarSvc", "Shared.ResponsiveSvc"];
        return Calendar;
    })();
    function calendar() {
        return {
            bindToController: {},
            controller: Calendar,
            controllerAs: "ctrl",
            scope: {},
            templateUrl: "app/calendar/calendar.html"
        };
    }
    Shared.calendar = calendar;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    var CalendarSvc = (function () {
        function CalendarSvc() {
            this.eventDirective = "shared-calendar-event-text";
            this.events = [];
            this.useWeekLabels = false;
            this.datesInRange = function (range) {
                var date = moment(range.start);
                var beforeDate = moment(range.end).add(1, "day");
                var result = [];
                while (date.isBefore(beforeDate)) {
                    result.push(date.format());
                    date.add(1, "day");
                }
                return result;
            };
        }
        CalendarSvc.$inject = [];
        return CalendarSvc;
    })();
    Shared.CalendarSvc = CalendarSvc;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    function dialog($animate, $compile, dialogSvc) {
        var $body;
        var $controls;
        var $element;
        var $previousFocus;
        function onFocus(e) {
            if (!$element[0].contains(e.target)) {
                e.stopPropagation();
                $element.focus();
            }
        }
        function template(scope, component, element, section) {
            var template = component.template;
            try {
                var content = $(component.template).first();
                if (content.length) {
                    scope.dialogSvc = dialogSvc;
                    content.attr("dialog", "dialogSvc.dialog");
                    content.attr("model", "dialogSvc.dialog." + section + ".model");
                    content.on("$destroy", function () {
                        var scope = content.isolateScope();
                        if (scope) {
                            scope.$destroy();
                        }
                    });
                    template = content;
                }
            }
            catch (e) { }
            element.empty().append(template);
            $compile(element.contents())(scope);
        }
        return {
            link: function (scope, element) {
                $body = element.find(".body").first();
                $controls = element.find(".controls").first();
                $element = element;
                scope.$watch(function () { return dialogSvc.isActive; }, function (n, o) {
                    if (n) {
                        template(scope, dialogSvc.dialog.body, $body, "body");
                        template(scope, dialogSvc.dialog.controls, $controls, "controls");
                        $element.css("display", "block");
                        $element.attr("tabIndex", "-1");
                        $animate.addClass(element, "active").then(function () {
                            $previousFocus = $(":focus");
                            element.focus();
                            document.addEventListener("focus", onFocus, true);
                        });
                    }
                    else {
                        dialogSvc.closeAnimation = $animate
                            .removeClass(element, "active")
                            .then(function () { return element.css("display", "none"); })
                            .then(function () {
                            document.removeEventListener("focus", onFocus, true);
                            if ($previousFocus && $previousFocus.length > 0) {
                                $previousFocus.focus();
                            }
                        });
                    }
                });
            },
            scope: {},
            templateUrl: "app/dialog/dialog.html"
        };
    }
    Shared.dialog = dialog;
    dialog.$inject = ["$animate", "$compile", "Shared.DialogSvc"];
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    var IDialog = (function () {
        function IDialog() {
        }
        return IDialog;
    })();
    Shared.IDialog = IDialog;
    var DialogSvc = (function () {
        function DialogSvc($q, $rootScope) {
            var _this = this;
            this.$q = $q;
            this.$rootScope = $rootScope;
            this.dialog = {
                body: {},
                controls: {},
                deferred: null
            };
            this.isActive = false;
            this.init = function () {
                if (_this.isActive) {
                    throw new Error("There is already a dialog visible");
                }
                _this.dialog.deferred = _this.$q.defer();
            };
            this.close = function () {
                var d = _this.$q.defer();
                _this.isActive = false;
                setTimeout(function () {
                    _this.closeAnimation.then(function () {
                        _this.closeAnimation = null;
                        d.resolve();
                    });
                }, 0);
                return d.promise;
            };
        }
        DialogSvc.prototype.alert = function (message) {
            return this.template(message, DialogSvc.controls.okay);
        };
        DialogSvc.prototype.confirm = function (message) {
            return this.template(message, DialogSvc.controls.yesNo);
        };
        DialogSvc.prototype.template = function (body, controls) {
            this.init();
            if (typeof body === "string") {
                this.dialog.body =
                    {
                        template: body
                    };
            }
            else {
                this.dialog.body = body;
            }
            if (typeof controls === "string") {
                this.dialog.controls =
                    {
                        template: controls
                    };
            }
            else {
                this.dialog.controls = controls;
            }
            this.isActive = true;
            return this.dialog.deferred.promise.finally(this.close);
        };
        DialogSvc.controls = {
            close: "<shared-dialog-okay text='Close'></shared-dialog-okay>",
            okay: "<shared-dialog-okay text='Okay'></shared-dialog-okay>",
            saveCancel: "<shared-dialog-yes-no text-yes='Save' text-no='Cancel'></shared-dialog-yes-no>",
            yesNo: "<shared-dialog-yes-no text-yes='Yes' text-no='No'></shared-dialog-yes-no>"
        };
        DialogSvc.$inject = ["$q", "$rootScope"];
        return DialogSvc;
    })();
    Shared.DialogSvc = DialogSvc;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    var DialogOkay = (function () {
        function DialogOkay() {
            var _this = this;
            this.okay = function () { return _this.dialog.deferred.resolve(_this.dialog); };
        }
        return DialogOkay;
    })();
    function dialogOkay() {
        return {
            bindToController: {
                dialog: "=",
                model: "=",
                text: "@"
            },
            controller: DialogOkay,
            controllerAs: "ctrl",
            scope: {},
            templateUrl: "app/dialog/okay/dialog-okay.html"
        };
    }
    Shared.dialogOkay = dialogOkay;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    var DialogYesNo = (function () {
        function DialogYesNo() {
            var _this = this;
            this.no = function () { return _this.dialog.deferred.reject(_this.dialog); };
            this.yes = function () { return _this.dialog.deferred.resolve(_this.dialog); };
        }
        return DialogYesNo;
    })();
    function dialogYesNo() {
        return {
            bindToController: {
                dialog: "=",
                model: "=",
                textNo: "@",
                textYes: "@"
            },
            controller: DialogYesNo,
            controllerAs: "ctrl",
            scope: {},
            templateUrl: "app/dialog/yes-no/dialog-yes-no.html"
        };
    }
    Shared.dialogYesNo = dialogYesNo;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    function dynamic($compile, $parse, $animate) {
        return {
            link: function (scope, element, attr) {
                var name = "shared-dynamic";
                var $element;
                if (!attr["type"]) {
                    throw Error("type attribute is required on shared-dynamic");
                }
                $element = element;
                scope.$watch(attr.type, function (n) {
                    if (n) {
                        var childScope = $element.isolateScope();
                        if (childScope) {
                            childScope.$destroy();
                        }
                        var parent = $element.parent();
                        var newElement = $($compile($element.get(0).outerHTML.replace(name, n))(scope));
                        $animate.leave($element).then(function () {
                            $animate.enter(newElement, parent);
                            $element = newElement;
                            name = ($element.get(0).tagName || "").toLowerCase();
                        });
                    }
                });
            },
            replace: true
        };
    }
    Shared.dynamic = dynamic;
    dynamic.$inject = ["$compile", "$parse", "$animate"];
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    function momentFilter() {
        return function (input, format) {
            if (format === "calendar") {
                return moment(input).calendar();
            }
            else {
                return moment(input).format(format);
            }
        };
    }
    Shared.momentFilter = momentFilter;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    var ResponsiveSvc = (function () {
        function ResponsiveSvc($rootScope) {
            var _this = this;
            this.minSM = 768;
            this.minMD = 992;
            this.minLG = 1200;
            this.maxXS = this.minSM - 1;
            this.maxSM = this.minMD - 1;
            this.maxMD = this.minLG - 1;
            var xs = window.matchMedia("(max-width: " + this.maxXS + "px)");
            xs.addListener(function (a) { return $rootScope.$applyAsync(function () { return _this.isXS = a.matches; }); });
            this.isXS = xs.matches;
            var sm = window.matchMedia("(min-width: " + this.minSM + "px) and (max-width: " + this.maxSM + "px)");
            sm.addListener(function (a) { return $rootScope.$applyAsync(function () { return _this.isSM = a.matches; }); });
            this.isSM = sm.matches;
            var md = window.matchMedia("(min-width: " + this.minMD + "px) and (max-width: " + this.maxMD + "px)");
            md.addListener(function (a) { return $rootScope.$applyAsync(function () { return _this.isMD = a.matches; }); });
            this.isMD = md.matches;
            var lg = window.matchMedia("(min-width: " + this.minLG + "px)");
            lg.addListener(function (a) { return $rootScope.$applyAsync(function () { return _this.isLG = a.matches; }); });
            this.isLG = lg.matches;
        }
        ResponsiveSvc.$inject = ["$rootScope"];
        return ResponsiveSvc;
    })();
    Shared.ResponsiveSvc = ResponsiveSvc;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    angular.module("shared.templates", []);
    var app = angular.module("shared", ["shared.templates", "ngAnimate"]);
    app.filter("moment", Shared.momentFilter);
    app.directive("sharedDialog", Shared.dialog);
    app.directive("sharedDialogOkay", Shared.dialogOkay);
    app.directive("sharedDialogYesNo", Shared.dialogYesNo);
    app.directive("sharedCalendar", Shared.calendar);
    app.directive("sharedCalendarEventText", Shared.calendarEventText);
    app.directive("sharedDynamic", Shared.dynamic);
    app.service("Shared.DialogSvc", Shared.DialogSvc);
    app.service("Shared.CalendarSvc", Shared.CalendarSvc);
    app.service("Shared.ResponsiveSvc", Shared.ResponsiveSvc);
})(Shared || (Shared = {}));

angular.module('shared.templates').run(['$templateCache', function ($templateCache) {  'use strict';

  $templateCache.put('app/calendar/calendar.html',
    "<div ng-if=!ctrl.responsiveSvc.isXS ng-class=\"{ 'use-week-labels': ctrl.calendarSvc.useWeekLabels }\" class=calendar-view><div class=week ng-repeat=\"w in ctrl.weeks\"><label ng-if=ctrl.calendarSvc.useWeekLabels><span ng-repeat=\"c in w.label track by $index\" ng-class=\"{ space: c === ' '}\">{{c}}</span></label><div class=day ng-repeat=\"d in w.days track by $index\" ng-class=\"{ 'out-of-range': !d.inRange, 'today': d.isToday }\"><div class=header><small>{{::d.date | date:'EEE'}}</small> <small>{{::d.date | date:'d'}}</small></div><ul class=events><li ng-repeat=\"e in d.events track by $index\"><div class=\"calendar-view event width-{{e.daysInWeek + ' ' + e.event.css}}\" ng-class=\"{ spacer: !e, start: e.includesStart, end: e.includesEnd, sunday: e.isSunday, saturday: e.includesSaturday }\"><div><shared-dynamic ng-show=e class=calendar-view type=\"e.event.directive || ctrl.calendarSvc.eventDirective\" instance-number={{e.instance}} days-in-instance={{e.daysInWeek}} model=e.event.model></shared-dynamic></div></div></li></ul></div></div></div><div ng-if=ctrl.responsiveSvc.isXS class=list-view><ul><li ng-repeat=\"d in ctrl.listDates\"><header>{{d.date | moment:'MMMM Do'}}</header><ul><li class=\"list-view event {{e.css}}\" ng-repeat=\"e in d.events track by $index\"><small ng-if=\"e.range.start !== e.range.end\">{{e.range.start | moment:'MMM Do'}} - {{e.range.end | moment:'MMM Do'}}</small><div><shared-dynamic ng-show=e class=list-view type=\"e.directive || ctrl.calendarSvc.eventDirective\" model=e.model></shared-dynamic></div></li></ul></li></ul></div>"
  );


  $templateCache.put('app/dialog/dialog.html',
    "<div><div class=body tb-modal-movable></div><div class=controls></div></div>"
  );


  $templateCache.put('app/dialog/okay/dialog-okay.html',
    "<button ng-click=ctrl.okay()>{{ctrl.text}}</button>"
  );


  $templateCache.put('app/dialog/yes-no/dialog-yes-no.html',
    "<button ng-click=ctrl.yes()>{{ctrl.textYes}}</button> <button ng-click=ctrl.no() class=hollow>{{ctrl.textNo}}</button>"
  );
} ]);